import Vue from 'vue'

const state = {
    profile: JSON.parse(localStorage.getItem('user-profile')) || {},
}

const getters = {
    user_profile: state => state.profile,
    is_profile_loaded: state => !!state.profile.prenom,
    //user_name: state => !!state.profile.prenom ? `${state.profile.prenom[0].toUpperCase()}${state.profile.prenom.substring(1).toLowerCase()} ${state.profile.nom[0].toUpperCase()}${state.profile.nom.substring(1).toLowerCase()}`:'',
    
    user_name: state => {
        let name =""

        // Nominal case firstname & name
        if(!!state.profile.prenom && !!state.profile.nom && state.profile.nom.length>0 && state.profile.prenom.length>0){
            name = `${state.profile.prenom[0].toUpperCase()}${state.profile.prenom.substring(1).toLowerCase()} ${state.profile.nom[0].toUpperCase()}${state.profile.nom.substring(1).toLowerCase()}`;
        }
        // set name only
        else if(!!state.profile.nom  && state.profile.nom.length>1){
            name = `${state.profile.nom[0].toUpperCase()}${state.profile.nom.substring(1).toLowerCase()}`;
        }
        // set firstname only
        else if(!!state.profile.prenom && state.profile.prenom.length>1){
            name = `${state.profile.prenom[0].toUpperCase()}${state.profile.prenom.substring(1).toLowerCase()}`;
        }else{
            name= 'Anonyme'
        }
        
        return name;
    },
    // user_initials: state => !!state.profile.prenom && !!state.profile.nom ? `${state.profile.prenom[0].toUpperCase()}${state.profile.nom[0].toUpperCase()}`:'',
    user_initials: state => {
        let name =""

        // Nominal case firstname & name
        if(!!state.profile.prenom && !!state.profile.nom && state.profile.nom.length>0 && state.profile.prenom.length>0){
            name = `${state.profile.prenom[0].toUpperCase()}${state.profile.nom[0].toUpperCase()}`;
        }
        // set name only
        else if(!!state.profile.nom && state.profile.nom.length>1 ){
            name = `${state.profile.nom[0].toUpperCase()}${state.profile.nom[1].toUpperCase()}`;
        }
        // set firstname only
        else if(!!state.profile.prenom && state.profile.prenom.length>1){
            name = `${state.profile.prenom[0].toUpperCase()}${state.profile.prenom[1].toUpperCase()}`;
        }else{
            name= 'AN'
        }
        
        return name;
    }

}




const actions = {
    // load_profile upon reconnexion
    set_user_profile: ({commit, dispatch}, data) => {
        // console.log('user profile', data.user);
        localStorage.setItem('user-profile', JSON.stringify(data.user));
        commit('SET_PROFILE', data);
    },
    remove_user_profile: ({commit, dispatch}) => {
        commit('SET_PROFILE', { user: {} });
        localStorage.removeItem('user-profile');
    },
}

const mutations = {
    SET_PROFILE: (state, data) => { Vue.set(state, 'profile', data.user) },
}


export default {
    state,
    getters,
    actions,
    mutations,
  }